import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function PhotocatalystsUseCase() {
  return (
    <>
    <section
      id="photocatalysts"
      className="min-h-screen pt-[96px] pb-20 px-6 sm:px-8 bg-[#1A1631] text-white scroll-mt-[96px]"
    >
      <div className="max-w-5xl mx-auto space-y-10">

        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        {/* Heading + Intro */}
        <div className="space-y-4">
          <h1 className="sm:text-2xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            Photocatalysts
          </h1>
          <p className="text-slate-300 space-y-2">
            Photocatalysts are materials that use light to drive chemical transformations — enabling sustainable processes in energy, environment, and synthesis. Organic photocatalysts (OPCs) offer more cost-effective and tunable structures with lower toxicity, and visible-light activity compared to heavy-metal-based systems, and are gaining traction in hydrogen evolution,<sup>[1]</sup> chemical synthesis,<sup>[2]</sup> CO₂ reduction, water splitting, and pollutant degradation.

            <br /><br />

            Effective OPCs must balance redox potential, photostability, excited-state lifetime, and intersystem crossing efficiency. Designing new scaffolds that support long-lived charge-separated states, suitable triplet energies, and minimal degradation under irradiation is challenging, especially when limited by lab throughput.
          </p>
        </div>

        {/* How Apoello Helps */}
<div className="space-y-4">
  <h2 className="text-2xl font-semibold text-orange-300">How DiaDEM™ helps</h2>
  <ul className="list-disc list-inside text-slate-300 space-y-2">
    <li>
      Explore organic photocatalysts with strong absorption in the visible spectrum.
    </li>
    <li>
      Access excited-state energy levels and redox potentials.
    </li>
    <li>
      Assess molecular and excited-state stability, and reorganisation energies to identify efficient photocatalytic scaffolds.
    </li>
    <li>
      Filter by solubility and access ready-to-purchase materials for lab testing.
    </li>
  </ul>
</div>

        {/* Why It Matters */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">Why It Matters</h2>
          <p className="text-slate-300 max-w-3xl">
            Photocatalysis sits at the heart of green chemistry, but progress is constrained by empirical workflows. DiaDEM™ enables rapid, predictive screening of organic photocatalysts — empowering chemists and material scientists to unlock new light-driven transformations without exhaustive lab synthesis.
          </p>
        </div>


        <div className="space-y-4 pt-10">
  <h2 className="text-2xl font-semibold text-orange-300">
    References from our group
  </h2>
  <ol className="list-decimal list-inside text-slate-400 space-y-1 text-sm">
    <li>
      Shi, L. & Troisi, A. <i>High-Throughput Screening of Molecule/Polymer Photocatalysts for the Hydrogen Evolution Reaction</i>, ACS Catal. <b>15</b>, 6690–6701 (2025).{" "}
      <a
        href="https://doi.org/10.1021/acscatal.5c01785"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#F89B3F] underline"
      >
        Link ↗
      </a>
    </li>
    <li>
      Villa, M., Fermi, A., Calogero, F., Wu, X., Gualandi, A., Cozzi, P. G., Troisi, A., Ventura, B. & Ceroni, P. <i>Organic super-reducing photocatalysts generate solvated electrons via two consecutive photon induced processes</i>, Chem. Sci. <b>15</b>, 14739–14745 (2024).{" "}
      <a
        href="https://doi.org/10.1039/D4SC04518A"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#F89B3F] underline"
      >
        Link ↗
      </a>
    </li>
  </ol>
</div>


        {/* CTA Button */}
        <div className="pt-8">
          <Link
            to="/diadem-overview"
            className="inline-block px-6 py-3 bg-[#EF7C34] text-white rounded-xl font-medium hover:bg-[#F89B3F] transition"
          >
            Explore the DiaDEM™ Platform →
          </Link>
        </div>

      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
